// @ts-nocheck
import Sheet from 'atoms/sheet/sheet';
import React from 'react';
import { Card } from 'antd';

const PageLayout = (props: TProps) => {
	return (
		<Card className={`${props.className} main-page-layout`}>
			<Sheet isPage>{props.children}</Sheet>
		</Card>
	);
};

export default PageLayout;
